/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserResponse
 */
export interface GetUserResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    status: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserResponse
     */
    emailConfirmed: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    createdOn: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    countryState?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    country?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserResponse
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    subscriptionPlanId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUserResponse
     */
    enabledMlsProviders?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    mlsId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    officeName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    trackingId: string;
    /**
     * 
     * @type {object}
     * @memberof GetUserResponse
     */
    avatar?: object | null;
    /**
     * 
     * @type {object}
     * @memberof GetUserResponse
     */
    initialLoginMethod?: object;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    initialSsoProvider?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    initialSsoIdentity?: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    brand?: string;
}

/**
 * Check if a given object implements the GetUserResponse interface.
 */
export function instanceOfGetUserResponse(value: object): value is GetUserResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('emailConfirmed' in value) || value['emailConfirmed'] === undefined) return false;
    if (!('createdOn' in value) || value['createdOn'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('trackingId' in value) || value['trackingId'] === undefined) return false;
    return true;
}

export function GetUserResponseFromJSON(json: any): GetUserResponse {
    return GetUserResponseFromJSONTyped(json, false);
}

export function GetUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'],
        'status': json['status'],
        'emailConfirmed': json['emailConfirmed'],
        'createdOn': json['createdOn'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'countryState': json['countryState'] == null ? undefined : json['countryState'],
        'country': json['country'] == null ? undefined : json['country'],
        'enabled': json['enabled'],
        'subscriptionPlanId': json['subscriptionPlanId'] == null ? undefined : json['subscriptionPlanId'],
        'enabledMlsProviders': json['enabledMlsProviders'] == null ? undefined : json['enabledMlsProviders'],
        'mlsId': json['mlsId'] == null ? undefined : json['mlsId'],
        'officeName': json['officeName'] == null ? undefined : json['officeName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'trackingId': json['trackingId'],
        'avatar': json['avatar'] == null ? undefined : json['avatar'],
        'initialLoginMethod': json['initialLoginMethod'] == null ? undefined : json['initialLoginMethod'],
        'initialSsoProvider': json['initialSsoProvider'] == null ? undefined : json['initialSsoProvider'],
        'initialSsoIdentity': json['initialSsoIdentity'] == null ? undefined : json['initialSsoIdentity'],
        'brand': json['brand'] == null ? undefined : json['brand'],
    };
}

export function GetUserResponseToJSON(json: any): GetUserResponse {
    return GetUserResponseToJSONTyped(json, false);
}

export function GetUserResponseToJSONTyped(value?: GetUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'status': value['status'],
        'emailConfirmed': value['emailConfirmed'],
        'createdOn': value['createdOn'],
        'timezone': value['timezone'],
        'countryState': value['countryState'],
        'country': value['country'],
        'enabled': value['enabled'],
        'subscriptionPlanId': value['subscriptionPlanId'],
        'enabledMlsProviders': value['enabledMlsProviders'],
        'mlsId': value['mlsId'],
        'officeName': value['officeName'],
        'phoneNumber': value['phoneNumber'],
        'trackingId': value['trackingId'],
        'avatar': value['avatar'],
        'initialLoginMethod': value['initialLoginMethod'],
        'initialSsoProvider': value['initialSsoProvider'],
        'initialSsoIdentity': value['initialSsoIdentity'],
        'brand': value['brand'],
    };
}

